<script>
import _ from 'lodash'
import UserActionRequiredCard from './UserActionRequiredCard.vue'
export default {
  components: {
    UserActionRequiredCard
  },
  props: {
    value: {
      type: Object
    },
    loading: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    orderId: {
      type: Number
    }
  },
  computed: {
    isUserActionRequired() {
      return (
        !_.isEmpty(this.value) &&
        Object.values(this.value).some(action => action)
      )
    },
    postageFailed() {
      return (
        !_.isEmpty(this.value) && this.value.needFrankingOnEnvelopeConfirmation
      )
    },
    prodAreaFailed() {
      return !_.isEmpty(this.value) && this.value.needProductionAreaConfirmation
    },
    fontFailed() {
      return !_.isEmpty(this.value) && this.value.needFontConfirmation
    },
    duplicatesFailed() {
      return !_.isEmpty(this.value) && this.value.needDuplicateDocumentsDelete
    },
    unapprovedFailed() {
      return !_.isEmpty(this.value) && this.value.needUnapprovedFilesDelete
    },
    warnings() {
      const userActionRequired = this.$enums.UserActionRequired
      let warnings = []
      this.postageFailed && warnings.push(userActionRequired.postage)
      this.prodAreaFailed && warnings.push(userActionRequired.productionNote)
      this.fontFailed && warnings.push(userActionRequired.font)
      this.duplicatesFailed && warnings.push(userActionRequired.duplicates)
      this.unapprovedFailed && warnings.push(userActionRequired.unapproved)
      return warnings
    }
  }
}
</script>
<template>
  <UserActionRequiredCard
    v-if="isUserActionRequired"
    :warnings="warnings"
    :loading="loading"
    :disabled="disabled"
    :order-id="orderId"
    identifier="upload-wizard-document-actions-confirmation-button"
    class="mb-4"
    @confirmWarnings="$emit('confirmWarnings')"
  />
</template>
